import React from "react";
import styled from "styled-components";
import { Button } from "antd";
import { useBreakpoints } from "../../lib/breakpoints";

const CardHeader = ({
  title,
  subtitle,
  actionButton,
  actionButtonText,
  onActionClick,
  children,
}) => {
  const { isMobile } = useBreakpoints();

  return (
    <HeaderContainer>
      <HeaderContent>
        <HeaderText>
          <HeaderTitle>{title}</HeaderTitle>
          {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
        </HeaderText>
        {actionButton && (
          <HeaderAction>
            <ActionButton
              type="primary"
              onClick={onActionClick}
              icon={actionButton}
            >
              {!isMobile && actionButtonText}
            </ActionButton>
          </HeaderAction>
        )}
      </HeaderContent>
      {children && <HeaderBody>{children}</HeaderBody>}
    </HeaderContainer>
  );
};

// Styled Components
const HeaderContainer = styled.div`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border-light);
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const HeaderContent = styled.div`
  background: var(--color-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1rem 1.5rem;
    text-align: center;
  }
`;

const HeaderText = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    text-align: center;
    width: 100%;
  }
`;

const HeaderTitle = styled.h2`
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  font-family: var(--font-primary);

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const HeaderSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  margin: 0.5rem 0 0 0;
  font-family: var(--font-secondary);

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const HeaderAction = styled.div`
  display: flex;
  align-items: center;
`;

const ActionButton = styled(Button)`
  background: rgba(255, 255, 255, 0.2) !important;
  background: transparent !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  border: none !important;
  color: white !important;
  border-radius: 12px;
  height: 40px;
  font-weight: 600;
  font-family: var(--font-secondary);
  transition: all 0.3s ease;
  position: absolute;
  right: 1rem;
  top: 0.5rem;

  .ant-btn-icon {
    filter: brightness(0) invert(1) !important;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    border-color: rgba(255, 255, 255, 0.5) !important;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    top: 0.25rem;
    right: 0.75rem;
    height: 36px;
    min-width: 36px;
    padding: 0 8px;
  }
`;

const HeaderBody = styled.div`
  flex: 1;
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
  }
`;

export default CardHeader;
